/**
 * Shared focus-visible styles for form controls.
 *
 * Uses the `border.focus` semantic token so focus rings follow
 * the company accent color set by admins via theming.
 */
export const outlineFocusVisible = {
	_focusVisible: {
		borderColor: 'border.focus',
		boxShadow: '0 0 0 1px var(--chakra-colors-border-focus)',
	},
};

export const flushedFocusVisible = {
	_focusVisible: {
		borderColor: 'border.focus',
		boxShadow: '0px 1px 0px 0px var(--chakra-colors-border-focus)',
	},
};
